<div class="flex-vertical background-white width-100pc oui-elevation-04 rounded padding-32 gap-48 card">
  <div class="header flex-vertical gap-16">
    <div class="flex-horizontal gap-32">
      <div>
        Vérifiez si les données investisseurs issues du recueil d’informations sont bien à jour avant de poursuivre la
        création de la fiche conseil.
      </div>
      <div class="flex-1"></div>
      <oui-button type="text" iconPrefix="cached" (click)="getConnaissanceClientData()"
        >Actualiser les données</oui-button
      >
    </div>
  </div>
  <ng-template #loading>
    <div class="flex-horizontal width-100pc flex-center justify-center">
      <oui-loading *ngIf="isLoadingConnaisanceClient"></oui-loading>
    </div>
  </ng-template>
  <ng-container *ngIf="!isLoadingConnaisanceClient; else loading">
    <div class="connaissanceBody">
      <div class="basicInfo flex-vertical gap-8">
        <div class="flex-horizontal investisseurHeaderContainer">
          <div class="categoryTitle flex-1"><h5>Situation personnelle</h5></div>

          <div class="investisseurHeader flex-1">
            <div class="body-2 color-on-surface-medium">Investisseur</div>
            <div class="flex-vertical">
              <div class="color-on-surface-emphasis subtitle-1">
                {{ currentFicheConseil?.investisseur?.displayName }}
              </div>
            </div>
            <a class="body-2 link" (click)="onModifyClick(false)">Modifier les données</a>
          </div>
          <div class="coInvestisseurHeader flex-1" *ngIf="currentFicheConseil?.coInvestisseur">
            <div class="body-2 color-on-surface-medium">Co-investisseur</div>
            <div class="flex-vertical">
              <div class="subtitle-1 color-on-surface-emphasis">
                {{ currentFicheConseil?.coInvestisseur?.displayName }}
              </div>
            </div>
            <a class="body-2 link" (click)="onModifyClick(true)">Modifier les données</a>
          </div>
        </div>
        <div class="profilInfo flex-vertical gap-8">
          <div class="infoContainer flex-vertical with-border border-bottomless rounded">
            <div class="infoLine">
              <div class="body-2 color-on-surface-medium flex-1 pairKey">Age</div>
              <div class="body-2 color-on-surface-emphasis flex-1 pairValue">
                {{ currentFicheConseil?.investisseur?.dateNaissance | ageInYears }}
              </div>
              <div
                class="body-2 color-on-surface-emphasis flex-1 pairValue"
                *ngIf="currentFicheConseil?.coInvestisseur">
                {{ currentFicheConseil?.coInvestisseur?.dateNaissance | ageInYears }}
              </div>
            </div>
            <div class="infoLine">
              <div class="body-2 color-on-surface-medium flex-1 pairKey">Profession (ou dernière profession)</div>
              <div class="body-2 color-on-surface-emphasis flex-1 pairValue">
                {{ currentFicheConseil?.investisseur?.situationPersonnelle?.profession ?? 'non renseigné' }}
                {{
                  currentFicheConseil?.investisseur?.situationPersonnelle?.categorieSocioProfessionnelleCode
                    ?.toString()
                    ?.startsWith('7')
                    ? '(Retraité(e))'
                    : ''
                }}
              </div>
              <div
                class="body-2 color-on-surface-emphasis flex-1 pairValue"
                *ngIf="currentFicheConseil?.coInvestisseur">
                {{ currentFicheConseil?.coInvestisseur?.situationPersonnelle?.profession ?? 'non renseigné' }}
                {{
                  currentFicheConseil?.coInvestisseur?.situationPersonnelle?.categorieSocioProfessionnelleCode
                    ?.toString()
                    ?.startsWith('7')
                    ? '(Retraité(e))'
                    : ''
                }}
              </div>
            </div>
            <div class="infoLine">
              <div class="body-2 color-on-surface-medium flex-1 pairKey">Situation matrimoniale</div>
              <div class="body-2 color-on-surface-emphasis flex-1 pairValue">
                {{ currentFicheConseil?.investisseur?.situationPersonnelle?.etatCivilTypeLibelle ?? 'non renseigné' }}
              </div>
              <div
                class="body-2 color-on-surface-emphasis flex-1 pairValue"
                *ngIf="currentFicheConseil?.coInvestisseur">
                {{ currentFicheConseil?.coInvestisseur?.situationPersonnelle?.etatCivilTypeLibelle ?? 'non renseigné' }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="profilInfo flex-vertical gap-8">
        <h5>Profil investisseur</h5>
        <div class="infoContainer flex-vertical with-border border-bottomless rounded">
          <div class="infoLine">
            <div class="body-2 color-on-surface-medium flex-1 pairKey">Profil de risque</div>
            <div class="body-2 color-on-surface-emphasis flex-1 pairValue">
              {{ currentFicheConseil?.investisseur?.profil?.profilQpiLibelle ?? 'Profil investisseur incomplet' }}
            </div>
            <div class="body-2 color-on-surface-emphasis flex-1 pairValue" *ngIf="currentFicheConseil?.coInvestisseur">
              {{ currentFicheConseil?.coInvestisseur?.profil?.profilQpiLibelle ?? 'Profil investisseur incomplet' }}
            </div>
          </div>
        </div>
        <oui-banner
          *ngIf="isBlocked"
          declination="error"
          [title]="'Vous devez finaliser la connaissance client de vos investisseurs avant de poursuivre.'"
          [showCloseButton]="false"></oui-banner>
      </div>
    </div>
  </ng-container>
</div>
